import React from 'react';
import styled from 'styled-components';
import PublicSiteLayout from '../../components/PublicSite/PublicSiteLayout';
import { CHANGELOG_ENTRIES } from './changelogEntries';
import { publicLine, publicText } from '../../components/PublicSite/publicColors';

const Title = styled.h1`
  font-size: clamp(2rem, 4vw, 2.75rem);
  margin: 0 0 1.5rem;
`;

const List = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 1.25rem;
`;

const Item = styled.li`
  border-top: 1px solid ${publicLine};
  padding-top: 1rem;
`;

const When = styled.time`
  display: block;
  color: ${publicText};
  opacity: 0.65;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
`;

const Heading = styled.h2`
  font-size: 1.15rem;
  margin: 0 0 0.35rem;
`;

const Note = styled.p`
  margin: 0;
  color: ${publicText};
  line-height: 1.5;
  max-width: 40rem;
`;

const ChangelogPage = (): JSX.Element => {
  return (
    <PublicSiteLayout>
      <Title>Changelog</Title>
      <List>
        {CHANGELOG_ENTRIES.map((entry) => (
          <Item key={`${entry.date}-${entry.title}`}>
            <When dateTime={entry.date}>{entry.date}</When>
            <Heading>{entry.title}</Heading>
            <Note>{entry.note}</Note>
          </Item>
        ))}
      </List>
    </PublicSiteLayout>
  );
};

export default ChangelogPage;
